import React from 'react';
// import { useHistory } from 'react-router-dom';

const AccessDenied = () => {
//   const navigate = useHistory();

  // const handleBackHome = () => {
  //   navigate('/');
  // };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.title}>Access Denied</h1>
        <p style={styles.message}>You do not have permission to view this page.</p>
        {/* <button onClick={handleBackHome} style={styles.button}>
          Go to Homepage
        </button> */}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    // backgroundColor: '#1C375D',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontFamily: 'Segoe UI, sans-serif',
  },
  card: {
    textAlign: 'center',
    backgroundColor: '#2e4c77',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 0 15px rgba(0,0,0,0.3)',
    maxWidth: '400px',
  },
  title: {
    fontSize: '3rem',
    marginBottom: '0.5rem',
    color: '#F47E46',
  },
  message: {
    fontSize: '1.2rem',
    marginBottom: '2rem',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1rem',
    backgroundColor: '#F47E46',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: '0.3s',
  },
};

export default AccessDenied;


